module.exports = __webpack_public_path__ + "catalog/items/espacios_42/4.2.jpg";